import { lazy } from "react";

const goodsAnalysis = lazy(() => import("../view/goodTotal/goodsAnalysis"));
const goodsTotal = [
  // 统计
  {
    path: "/goodTotal/goodsAnalysis",
    component: goodsAnalysis,
  },
];
export default goodsTotal;